var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgMoreVertical = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "M9 10.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25m0 5.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25m0-10.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25" }) }))); };
export default SvgMoreVertical;
